import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiData, TopNavMenuClickBiEvent } from '@wix/da-bi/pkg/events';

export function useStudioItem() {
  const { t } = useTranslation();
  return {
    label: t('siteHeader.userMenu.myStudio'),
    link: Url.studio({ section: 'home' }),
    biData: BiData<TopNavMenuClickBiEvent>({
      evid: 702,
      link_url: Url.studio({ section: 'home' }),
      menu_item: 'my_studio',
      menu_name: 'profile',
    }),
  };
}
